import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import NavigationList from "./NavigationList";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobileNavbar: {
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      width: "100%",
      height: "13vh",
      backgroundColor: theme.palette.secondary.main,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    menuIcon: {
      position: "absolute",
      right: "5%",
      top: "50%",
      transform: "translateY(-50%)",
    },
    logo: {
      position: "absolute",
      left: "5%",
      height: "7vh",
      width: "auto",
      top: "50%",
      transform: "translateY(-50%)",
    },
  })
);

interface IProps {
  pathname: string;
}

const MobileNavigator: React.FC<IProps> = ({ pathname }: IProps) => {
  const [openNav, setOpenNav] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setOpenNav(false);
  }, [pathname]);

  return (
    <Box className={classes.mobileNavbar} style={{ position: openNav ? "fixed" : "absolute" }}>
      <Link to={"/"}>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} className={classes.logo} alt={"logo-obiektu"} />
      </Link>
      <IconButton className={classes.menuIcon} onClick={() => setOpenNav((open) => !open)} color={"primary"}>
        <MenuIcon fontSize={"large"} />
      </IconButton>
      {openNav && (
        <Box
          style={{
            position: "fixed",
            top: "13vh",
            backgroundColor: "#333",
            height: "87vh",
            zIndex: 10000,
          }}
        >
          <NavigationList fullScreen width={"100vw"} pathname={pathname} />
        </Box>
      )}
    </Box>
  );
};

export default MobileNavigator;
